import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "FontAwesome__arrow-right-long-sharp-regular",
  "use": "FontAwesome__arrow-right-long-sharp-regular-usage",
  "viewBox": "0 0 512 512",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 512 512\" id=\"FontAwesome__arrow-right-long-sharp-regular\"><!--!Font Awesome Pro 6.5.1 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license (Commercial License) Copyright 2023 Fonticons, Inc.--><path d=\"m495 273 17-17-17-17-136-136-17-17-33.9 34 17 17 95 95H0v48h420.1l-95 95-17 17 33.9 33.9 17-17L495 273z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol